// 金鑰只從這個檔案讀取；留空時不呼叫 Google，門市清單與導航連結仍可使用。
// 目前填的是網站金鑰（限制：僅 Maps JavaScript API；網站 katadyn.mabuvalley.com 與 localhost:8765）。
// 僅接受供 Maps JavaScript API 使用的網站金鑰（AIza 開頭），不要放入服務帳戶授權金鑰（AQ. 開頭）。
// 網站金鑰須在 Google Cloud 設定網站（HTTP referrer）與 API 限制；其餘待核對門市保持在清單，不顯示猜測標記。
window.KATADYN_MAP_CONFIG = {
  apiKey: 'AIzaSyAzu1Id3wNX3xrw_tGQ7VFDsAacpeVTbuM',
  mapId: ''
};
